import React from 'react';
import { useEffect, useState } from 'react';
import { useUserProfile } from '../helper/UserProfile';
import supabase from '../helper/supabaseClient';
import '../stylesheets/dashboard.scss';
import '../stylesheets/profile.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import MobileProfile from './mobile/MobileProfile';

function Competencies() {

  const [userCompetencies, setUserCompetencies] = useState([]);
  const [allCompetencies, setAllCompetencies] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  
  const { profile, loading } = useUserProfile();

  useEffect(() => {
    const fetchAllCompetencies = async () => {
      const { data } = await supabase
        .from('instructor_competencies')
        .select('competencies')
        .order('competencies', { ascending: true });
      setAllCompetencies(data || []);
    };

    const fetchUserCompetencies = async () => {
      if (!profile) return;
      
      const { data } = await supabase
        .from('profile')
        .select('competencies')
        .eq('id', profile.id)
        .single();

      // Convert the comma-separated string back to an array
      if (data?.competencies) {
        const competenciesArray = data.competencies.split(',').map(item => item.trim());
        setUserCompetencies(competenciesArray);
      } else {
        setUserCompetencies([]);
      }
    };

    fetchAllCompetencies();
    fetchUserCompetencies();
  }, [profile]);

  const handleCheckboxChange = (competency) => {
    setUserCompetencies(prev => 
      prev.includes(competency)
        ? prev.filter(item => item !== competency)
        : [...prev, competency]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Convert array to comma-separated string for Supabase
    const competenciesString = userCompetencies.join(', ');

    const { error } = await supabase
      .from('profile')
      .update({ 
        competencies: competenciesString 
      })
      .eq('id', profile.id);

    if (error) {
      setError("Could not update competencies");
      console.error(error);
      return;
    }

    setSuccess("Competencies updated successfully!");
    setTimeout(() => setSuccess(""), 3000);
  };

  if (loading) return <div><FontAwesomeIcon icon={faSpinner} style={{position: "absolute", top: "5rem", left: "50%", transform: "translate(-50%, 0)", fontSize: "40px"}}/></div>;
  
  return (
    <div>
      <div className="mob-only">
        <MobileProfile />
      </div>  
      <div className="dashboard-body">
        <h1>YOUR COMPETENCIES</h1>
        <p>Please select all your instructor competencies and qualifications. This will decide the courses you will be allowed to register to teach. You will be asked to provide proof of qualification before you are allowed to sign up to teach courses.</p>

        {allCompetencies.map((q) => (<label key={q.id}>{q.allCompetencies}</label>))}

        <form onSubmit={handleSubmit}>
          <table>
            <tr className="qualification-checkbox">
              <th style={{textAlign:"left", verticalAlign: "top", paddingRight: "2rem"}}>Competencies</th>
              <td>
                 {allCompetencies.map(({ competencies }) => (
                    <label key={competencies} style={{display: 'block'}}>
                      <input
                        type="checkbox"
                        checked={userCompetencies.includes(competencies)}
                        onChange={() => handleCheckboxChange(competencies)}
                      />
                      {competencies}
                    </label>
                  ))}
              </td>
            </tr>
          </table>
          <br></br>
          <button type="submit">Update</button>
        </form>
        <br></br>
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success">{success}</p>} 
        <p>If you have a competency that isn't on the list that you believe should be, please <a href="mailto:jamie.lennon@1664trainingsolutions.co.uk" className="clickable-link">email us</a> and we will review your submission.</p>
        <div className="mob-bottom-buffer"></div>
      </div>
    </div>
  );
}

export default Competencies;